import { DropdownMenuCheckboxItem } from '@ais-ui/ui-core';
import { useReportContext } from '../ReportContext';
import { ParsedReportParams } from '@ais-ui/websockets';
import { useLocalization } from '@ais-ui/locale-management';

function shouldShowTracks(
  reportType: string | null,
  reportDetails: ParsedReportParams | null,
): boolean {
  const showTrackOption = [
    'AREA_STAT_TB',
    'MULTI_AREA',
    'PASSAGELINE_TB',
    'DATA_PASSAGELINE_MULTI',
    'PILOTBOAT_TRIPS',
    'TUGBOAT_OPERATIONS',
  ];

  if (!reportDetails || !reportDetails.params || !reportType) {
    return false;
  }

  if (
    reportType === 'AREA_STAT_TB' &&
    reportDetails.params['STG'] === 'shiplist'
  ) {
    return false;
  }
  return showTrackOption.includes(reportType);
}

function shouldShowOnlyTargetsInView(reportType: string | null): boolean {
  const showTargetsInViewOption = ['HISTORY_TRACK_TB'];

  if (!reportType) {
    return false;
  }

  return showTargetsInViewOption.includes(reportType);
}

/**
 * Report-specific toggles ("show tracks", "show only targets in view"), rendered
 * as checkbox items inside the table's unified Actions menu. Returns null when
 * the current report type exposes no options, so the caller can compose it
 * directly inside <TableDock.Actions>.
 */
export const ReportsOptionsMenuItems = () => {
  const { messages } = useLocalization();
  const {
    reportType,
    reportDetails,
    showTracks,
    setShowTracks,
    filterByMapView,
    setFilterByMapView,
  } = useReportContext();

  const showTracksOption = shouldShowTracks(reportType, reportDetails);
  const showTargetsInViewOption = shouldShowOnlyTargetsInView(reportType);

  if (!showTracksOption && !showTargetsInViewOption) {
    return null;
  }

  return (
    <>
      {showTracksOption && (
        <DropdownMenuCheckboxItem
          checked={showTracks}
          onCheckedChange={setShowTracks}
          onSelect={(event) => event.preventDefault()}
        >
          {messages.reportsTableOptionsShowTracksLabel}
        </DropdownMenuCheckboxItem>
      )}
      {showTargetsInViewOption && (
        <DropdownMenuCheckboxItem
          checked={filterByMapView}
          onCheckedChange={setFilterByMapView}
          onSelect={(event) => event.preventDefault()}
        >
          {messages.reportsTableOptionsShowOnlyTargetsLabel}
        </DropdownMenuCheckboxItem>
      )}
    </>
  );
};
